$shm_prereleasefixtureapp $mol_view
	sub /
		<= Title $mol_view
			sub / \Prerelease timing
		<= Message $mol_view
			sub / <= message \
